import React from "react";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const MotivationForm = ({ analysesMarqTumFactory, updateAnalysesMarqTum, analysesPregnantFactory, updateAnalysesPregnant }) => (
	<div>
		<MultipleSelect factory={analysesMarqTumFactory} update={updateAnalysesMarqTum} />
		<MultipleSelect factory={analysesPregnantFactory} update={updateAnalysesPregnant} />
	</div>
);

export default MotivationForm;
